import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import moment from '../../../../common/constants/moment';
import CommonDatePicker from '../../../../components/date-picker/CommonDatePicker';
import Dropdown from '../../../../components/dropdown/Dropdown';
import { DataPayslipItemCategory } from './constants/DataPayslipCategories';
import { Input, Select } from 'antd';
import CrossIcon from '../../../../assets/icons/CrossIcon';
import CommonTable from '../../../../components/common-table/CommonTable';
import Button from '../../../../components/button/Button';
import {
    addDataPayslip,
    removeDataPayslip,
    updateDataPayslip,
} from '../../../../redux/reducers/onboarding/sliceReducer';
import { commonDateMonthFormat, commonDTOPeriod } from '../../../../common/constants/dateConstants';
import DeleteDataPayslipModal from './constants/DeleteDataPayslipModal';
import { openSuccessNotification } from '../../../../components/notification/Notification';
import TrashIcon from '../../../../assets/icons/TrashIcon';
import AngleIcon from '../../../../assets/icons/AngleIcon';

const DataPayslipTab = () => {
    const dispatch = useAppDispatch();
    const { dataPayslipItems } = useAppSelector((state) => state.onboarding.dataPayslip);
    const [selectedDelete, setSelectedDelete] = useState<number | null>(null);
    const errorMessages = useAppSelector((state) => state.onboarding.validationError.dataPayslip);
    const getError = (fieldName: string): string => {
        if (errorMessages) {
            return errorMessages[fieldName] ?? '';
        }
        return '';
    };

    const onClose = () => {
        setSelectedDelete(null);
    };

    const onDelete = () => {
        if (selectedDelete !== null) {
            dispatch(removeDataPayslip(selectedDelete));
            openSuccessNotification('The data payslip was deleted successfully.');
            onClose();
        }
    };

    const data: any = dataPayslipItems?.map((item, index) => {
        return {
            period: item?.period || null,
            category: item?.category || '',
            amount: item?.amount || 0,
            comment: item?.comment || '',
            key: index,
        };
    });

    const columns: any = [
        {
            title: 'Period',
            dataIndex: 'period',
            width: 90,
            render: (text: any, data: any) => {
                return (
                    <CommonDatePicker
                        label=""
                        changeDate={(date) => {
                            dispatch(
                                updateDataPayslip({
                                    key: 'period',
                                    index: data.key,
                                    value: date ? moment(date).startOf('month').format(commonDTOPeriod) : '',
                                })
                            );
                        }}
                        defaultValue={data.period}
                        picker="month"
                        bodyContainer
                        style={{
                            border: getError(`data.dataPayslipItems[${data.key}].period`) ? '1px solid #e02b1d' : '',
                            borderRadius: getError(`data.dataPayslipItems[${data.key}].period`) ? '5px' : '',
                        }}
                    />
                );
            },
        },
        {
            title: 'Category',
            dataIndex: 'category',
            width: 120,
            render: (text: string, data: any) => (
                <Select
                    options={Object.keys(DataPayslipItemCategory).map((item) => {
                        return {
                            label: DataPayslipItemCategory[item as keyof typeof DataPayslipItemCategory],
                            value: DataPayslipItemCategory[item as keyof typeof DataPayslipItemCategory],
                        };
                    })}
                    onChange={(value) => {
                        dispatch(
                            updateDataPayslip({
                                key: 'category',
                                index: data.key,
                                value,
                            })
                        );
                    }}
                    className="tax-dropdown"
                    style={{
                        width: '100%',
                        border: getError(`data.dataPayslipItems[${data.key}].category`) ? '1px solid #e02b1d' : '',
                        borderRadius: getError(`data.dataPayslipItems[${data.key}].category`) ? '5px' : '',
                    }}
                    suffixIcon={<AngleIcon />}
                    value={text}
                />
            ),
        },
        {
            title: 'Amount (CHF)',
            dataIndex: 'amount',
            width: 80,
            render: (text: any, data: any) => {
                return (
                    <Input
                        type="number"
                        value={text}
                        bordered={false}
                        style={{
                            fontSize: '12px',
                            border: getError(`data.dataPayslipItems[${data.key}].amount`) ? '1px solid #e02b1d' : '',
                            borderRadius: getError(`data.dataPayslipItems[${data.key}].amount`) ? '5px' : '',
                        }}
                        onChange={(e) =>
                            dispatch(
                                updateDataPayslip({
                                    key: 'amount',
                                    index: data.key,
                                    value: e.target.value,
                                })
                            )
                        }
                    />
                );
            },
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            width: 100,
            render: (text: any, data: any) => {
                return (
                    <Input
                        value={text}
                        bordered={false}
                        style={{
                            fontSize: '12px',
                            border: getError(`data.dataPayslipItems[${data.key}].comment`) ? '1px solid #e02b1d' : '',
                            borderRadius: getError(`data.dataPayslipItems[${data.key}].comment`) ? '5px' : '',
                        }}
                        onChange={(e) =>
                            dispatch(
                                updateDataPayslip({
                                    key: 'comment',
                                    index: data.key,
                                    value: e.target.value,
                                })
                            )
                        }
                    />
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            width: 60,
            render: (text: string, data: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <TrashIcon
                            onClick={() => {
                                setSelectedDelete(data.key);
                            }}
                        />
                    </div>
                );
            },
        },
    ];

    return (
        <div className="tax-table-wrapper">
            {getError('data.dataPayslipItems') && (
                <span className="error-message error-text">
                    <div className="icon-wrapper">
                        <CrossIcon />
                    </div>
                    {getError('data.dataPayslipItems')}
                </span>
            )}
            <CommonTable
                columns={columns}
                data={data}
                tableHeight={300}
                height={300}
                hidePagination
                hasRowDatePicker
                rowKey="key"
                key="key"
                isBorderedTable
            />
            <Button
                buttonSize="medium"
                buttonStyle="primary"
                buttonWidth={'100%'}
                className={`add-tax-item-btn-`}
                onClick={() => {
                    dispatch(addDataPayslip());
                }}
            >
                + Add line
            </Button>
            {selectedDelete !== null && (
                <DeleteDataPayslipModal isOpen={selectedDelete !== null} onClose={onClose} onSubmit={onDelete} />
            )}
        </div>
    );
};

export default DataPayslipTab;
